"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATEMENT_PERIOD_STATUSES = exports.DISTRIBUTION_TYPES = exports.CURRENCIES = exports.CONTRACT_TERM_TYPES = exports.ADJUSTMENT_FILE_COLUMNS = void 0;
var _snowflakeClient = require("@abacus/snowflake-client");
var _types = require("./types");
const ADJUSTMENT_FILE_COLUMNS = exports.ADJUSTMENT_FILE_COLUMNS = new Set(Object.values(_types.AdjustmentFileColumn));
const CONTRACT_TERM_TYPES = exports.CONTRACT_TERM_TYPES = new Set([_snowflakeClient.ContractTermType.Label, _snowflakeClient.ContractTermType.Product]);
const CURRENCIES = exports.CURRENCIES = new Set(Object.values(_types.Currency));
const DISTRIBUTION_TYPES = exports.DISTRIBUTION_TYPES = new Set([_types.DistributionType.Digital, _types.DistributionType.Physical]);
const STATEMENT_PERIOD_STATUSES = exports.STATEMENT_PERIOD_STATUSES = new Set([_snowflakeClient.StatementPeriodStatus.Current]);